import { nextTick, type Directive } from 'vue'

export const autofocus: Directive<HTMLElement> = {
  mounted(el, binding) {
    if (binding.value === false) return
    nextTick().then(() => el.focus())
  },
  updated(el, binding) {
    if (binding.oldValue === false && binding.value === true) {
      nextTick().then(() => el.focus())
    }
  },
}
